import { render, staticRenderFns } from "./LengthMarkerOld.vue?vue&type=template&id=4c3be648&scoped=true"
import script from "./LengthMarkerOld.vue?vue&type=script&lang=js"
export * from "./LengthMarkerOld.vue?vue&type=script&lang=js"
import style0 from "./LengthMarkerOld.vue?vue&type=style&index=0&id=4c3be648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3be648",
  null
  
)

export default component.exports